export enum REVIEWS_PAGE_TABS {
    PRODUCT_REVIEWS = "product_reviews",
    SITE_REVIEWS = "site_reviews",
}
